<template>
	<footer class="footer">
		<div class="container inner">
			<span class="brand">
				<img src="/img/logo-mark-white.png" alt="" width="28" height="28" />
				Pablo Cerino Jiu-Jitsu School · Icon Brussels
			</span>
			<span class="mono">{{ contact.addressLine1 }}, {{ contact.addressLine2 }} · © {{ year }}</span>
		</div>
	</footer>
</template>

<script>
import { contact } from "../../data/site.js";

export default {
	data() {
		return { contact, year: new Date().getFullYear() };
	},
};
</script>

<style scoped>
.footer {
	background: var(--ink);
	color: #cfcfcf;
}

.inner {
	padding-top: 28px;
	padding-bottom: 28px;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	align-items: center;
	gap: 16px;
	font-size: 14px;
}

.brand {
	display: flex;
	align-items: center;
	gap: 12px;
}

@media (max-width: 768px) {
	.inner {
		padding-bottom: 36px;
		flex-direction: column;
		align-items: flex-start;
	}

	.mono {
		font-size: 12px;
	}
}
</style>
